function isMobile() {
  return window.innerWidth <= 768;
}

function initSlider() {
  if (!isMobile()) return;

  const swiper = new Swiper(".new-spirits-slider", {
    direction: "horizontal",
    slidesPerView: isMobile() ? 2.5 : 7,
    slidesPerGroupSkip: 1,
    spaceBetween: 12,
    loop: true,
  });
}

function initDesktopSpirits() {
  const spiritsContainer = document.querySelector(".new-spirits");
  const isAtcMode = spiritsContainer?.dataset.atcMode === 'true';
  const spirits = document.querySelectorAll(".new-spirits-desktop .spirit-slide .spirit-info");

  const toggleCTA = (e) => {
    const slide = e.target.closest(".spirit-slide");
    if(!slide) return;
    
    // In ATC mode, allow clicks on image and title to redirect to PDP
    if (isAtcMode && (e.target.tagName === 'IMG' || e.target.tagName === 'H4')) {
      const productUrl = slide.dataset.productUrl;
      if (productUrl) {
        window.location.href = productUrl;
      }
      return;
    }
    
    if (isAtcMode) {
      return;
    }
    
    document.querySelectorAll(".new-spirits-desktop .spirit-slide.slide-active").forEach(elm => elm.classList.remove("slide-active"));
    slide.classList.add("slide-active");

    slide.querySelector("a.spirit-btn")?.click();
  }

  spirits.forEach(elm => elm.addEventListener("click", toggleCTA))
}

function initMobileSpirits() {
  const spiritsContainer = document.querySelector(".new-spirits");
  const isAtcMode = spiritsContainer?.dataset.atcMode === 'true';
  
  if (!isAtcMode) return;
  
  const mobileSpirits = document.querySelectorAll(".new-spirits-slider .spirit-slide .spirit-info");
  
  mobileSpirits.forEach(elm => {
    elm.addEventListener("click", (e) => {
      const slide = e.target.closest(".spirit-slide");
      if (!slide) return;
      
      // In ATC mode, allow clicks on image and title to redirect to PDP
      if (e.target.tagName === 'IMG' || e.target.tagName === 'H4') {
        const productUrl = slide.dataset.productUrl;
        if (productUrl) {
          window.location.href = productUrl;
        }
      }
    });
  });
}

function initSpiritATC() {
  const atcButtons = document.querySelectorAll('.spirit-atc-btn');
  
  atcButtons.forEach(button => {
    button.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      const variantId = button.dataset.variantId;
      
      if (!variantId || button.disabled) return;
      
      button.disabled = true;
      button.classList.add('loading');
      
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        });
        
        if (!response.ok) {
          throw new Error('Failed to add to cart');
        }
        
        const data = await response.json();
        
        button.classList.remove('loading');
        button.classList.add('product-added');
        
        const cartCountElements = document.querySelectorAll('.cart-count-bubble span, [data-cart-count]');
        fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {
            cartCountElements.forEach(el => {
              el.textContent = cart.item_count;
            });
          });
        
        setTimeout(() => {
          button.classList.remove('product-added');
          button.disabled = false;
        }, 2000);
        
      } catch (error) {
        console.error('Error adding to cart:', error);
        button.classList.remove('loading');
        button.disabled = false;
        alert('Failed to add product to cart. Please try again.');
      }
    });
  });
}

initSlider();
document.addEventListener("DOMContentLoaded", () => {
  initDesktopSpirits();
  initMobileSpirits();
  initSpiritATC();
});


